module.exports = __webpack_public_path__ + "static/media/bell.0c9742ab.svg";